<template>
  <div class="Com_smart_1">
    <title1 type="1" title="场站数量统计" />
    <div class="bottom">
      <div class="back_1">
        <div class="before"></div>
        <div class="target">
          <div class="title">已有场站数量(座)</div>
          <div class="number">22,272</div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import title1 from "@/views/exposition/components/title4";
import { dataInterface } from "@/api/dataInterfaceApi";
export default {
  components: {
    title1,
  },
  data() {
    return {
      target: {},
      query: this.$route.query,
    };
  },
  methods: {
    serverOverview() {
      // console.log(this.query,'query666666')
      let cityCode = this.query.province || this.query.city || "000000";
      console.log(cityCode, "query666666");
      let params = {
        enCode: "zngf-qg-gfcztj", // 接口code
        "@adcode": cityCode, // 接口传参
      };
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          console.log(res, "光伏场站概括");
          let data1 = res[0] || {};
          this.target = data1 || {};
        })
        .catch((err) => {
          console.log(err);
        });

      let params1 = {
        enCode: "zngf-qg-gfdzyxztfbqk", // 接口code
        "@adcode": cityCode, // 接口传参
      };

      dataInterface
        .dataFaceApi(params1)
        .then((res) => {
          console.log(res, "光伏场站概括2");
          let data1 = res[0] || {};
          this.target2 = data1 || {};
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  destroyed() {
    // this.$bus.$off('onfangdiangonglv')
  },
  mounted() {
    this.serverOverview();
  },
};
</script>
  
  <style lang="scss" scoped>
@import "@/views/components/energyStorage/comm.scss";

.Com_smart_1 {
  width: 100%;
  height: 200px;

  .bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 150px;
    .back_1 {
      width: 420px;
      height: 116px;
      background: url(~@/assets/images/smart/back-1.png) no-repeat;
      background-size: 100%;
      display: flex;
      padding: 18px;
      position: relative;
    }
    .before {
      width: 77px;
      height: 85px;
      // background: red;
    }
    .target {
      padding-left: 20px;
      flex: 1;
      // background: skyblue;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .title {
        font-size: 18px;
      }
      .number {
        font-size: 48px;
        @include ffamily-DS;
      }
    }
  }
}
</style>